// extracted by mini-css-extract-plugin
export var container = "styles-module__container___pvj1k";
export var title = "styles-module__title____HtJs";
export var coordinates = "styles-module__coordinates___GvjJc";